import styles from "./PreviousPollsResult.module.css";

const previousPollsResultStyle = {
    outerContainer: `bg-themeColor rounded-[10px] px-[15px] py-[10px] flex flex-col gap-[8px] ${styles.outerContainer}`,
    heading: ` text-[17px] font-Suisse font-[700] leading-[24px] flex flex-col gap-2 ${styles.heading}`,
    dividerContainer: `flex gap-2 w-[30%]`,
    divider: `bg-primaryHeading h-[2px]`,
    pollsContainer: `flex flex-wrap gap-[13px] w-full justify-between min-h-[275px] ${styles.pollsContainer}`,
    insidePollsContainer: `max-h-[275px] flex flex-wrap  gap-[13px] pr-2 overflow-y-auto w-full`,
    pollsData:`flex flex-col gap-2 w-[98%]`,
    pollsWrapper: `space-y-2`,
    loaderContainer: `w-full h-full flex flex-col items-center justify-center`,
    noPollsContainer: `flex flex-col items-center justify-center py-10 w-full ${styles.noPollsContainer}`,
    noPollsImage:  `w-full h-[auto] max-w-[120px] ${styles.noPollsImage}`,
    noPollsText: `text-white text-lg ${styles.noPollsText}`,
    skeletonContainer: `max-h-[275px] overflow-y-auto pr-2 grid grid-cols-1 gap-[13px] w-full
                        lg:grid-cols-2
    `,
}

export { previousPollsResultStyle }